<template>
  <div>
    <y-periodselector
      @period="periodselected"
      :iscierre="true"
      :period="period"
    ></y-periodselector>
    <div class="field is-grouped">
      <div class="control">
        <button type="submit" class="button is-light" @click="downloadmonth">
          <span class="icon is-small">
            <span class="material-icons">archive</span>
          </span>
          <span>Descargar mes</span>
        </button>
      </div>
      <div class="control">
        <button type="submit" class="button is-light" @click="downloadyear">
          <span class="icon is-small">
            <span class="material-icons">archive</span>
          </span>
          <span>Descargar año</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      period: {
        year: null,
        months: null,
      },
    };
  },
  computed: {
    ...mapState(["empresa"]),
    periodo() {
      const year = this.period.year;
      let month = this.period.months[0];
      month = month.toString();
      if (month.length === 1) {
        month = `0${month}`;
      }
      return `${year}${month}`;
    },
  },
  methods: {
    async downloadmonth() {
      try {

        let result = await apiServices.post(
          `/reporteauxiliar`,
          { periodo: this.period },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        let ahora = new Date();
        ahora = ahora.toISOString();
        link.setAttribute(`download`, `Auxiliar-mes-${ahora}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    async downloadyear() {
      try {
        let result;
        result = await apiServices.post(
          `/reporteauxiliaryear`,
          { year: this.period.year },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        let ahora = new Date();
        ahora = ahora.toISOString();
        link.setAttribute(`download`, `Auxiliar-año-${ahora}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    periodselected(period) {
      this.period = period;
    },
  },
  created() {
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
  },
  components: {
    yPeriodselector,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/reports/auxiliar/Auxiliar.vue